<template>
  <div class="dashboard-view">
    <section class="section">
        <div class="container is-fluid">
          <h1 class="title">Active Searches</h1>
          <h2 class="subtitle">
              All your monitored search queries are listed below
          </h2>            
        </div>
    </section>

    <section class="section query-section" v-for="(query, queryIndex) in this.queries" :key="queryIndex">
      <div class="container is-fluid">

        <div class="columns query-header">
          <div class="column is-10">
            <h1 v-html="query.title" class="title query-title"></h1>
          </div>
          <div class="column price-column">
            <h1 v-html="priceRangeForQuery(query)" class="title query-price-range"></h1>
          </div>
        </div>

        <div class="sources-container">
          <span
            class="tag is-primary source-tag"
            v-for="(source, index) in query.sources"
            :key="index">
              {{ source }}
          </span>
        </div>

        <div class="columns listings-container">
          <div class="column is-one-fifth miniature-column" v-for="(listing, listingIndex) in query.listings" :key="listingIndex">
            <ListingMiniature
              :listing="listing"
              :queryIndex="queryIndex"
              :listingIndex="listingIndex"
              @clicked="onMiniatureViewClicked" />
          </div>
        </div>
      </div>
    </section>

    <b-modal
      scroll="keep"
      :active.sync="modalActive"
      :width="678"
      :canCancel="true">
      <ListingModalContent
        @discarded="onDiscarded"
        :listing="selectedListing"
        :listingIndex="selectedListingIndex"
        :queryIndex="selectedQueryIndex" />
    </b-modal>
  </div>
</template>

<script>

import ListingModalContent from "@/components/ListingModalContent.vue"
import ListingMiniature from "@/components/ListingMiniature.vue"

export default {
  name: "Dashboard",
  components: {
      ListingModalContent,
      ListingMiniature
  },
  data() {
    return {
      selectedListing: {
        id: 0,
        title: "Lorem dolor",
        description: "Lorem dolor sit amet",
        price: 100,
        imageURL: "",
        publishedDate: ""
      },
      selectedListingIndex: 0,
      selectedQueryIndex: 0,
      modalActive: false,
      queries: JSON.parse(localStorage.queries)
    }
  },
  methods: {
    onMiniatureViewClicked (queryIndex, listingIndex) {
      this.selectedListing = this.queries[queryIndex].listings[listingIndex];
      this.selectedListingIndex = listingIndex
      this.selectedQueryIndex = queryIndex

      this.modalActive = true;
    },
    onDiscarded (queryIndex, listingIndex) {
      let listing = this.queries[queryIndex].listings[listingIndex];
      this.queries[queryIndex].listings.splice(listingIndex, 1);
      this.modalActive = false;

      this.$buefy.snackbar.open({
        message: "Listing " + listing.title + " deleted.",
        type: "is-warning",
        position: "is-top",
        actionText: "Undo",
        duration: 5000,
        onAction: () => {
          this.queries[queryIndex].listings.splice(listingIndex, 0, listing);
        }
      })
    },
    priceRangeForQuery(query) {
      if (query.priceRange == null) return "";
      return query.priceRange[0] + "-" + query.priceRange[1] + "€";
    }
  }
};

</script>

<style lang="scss" scoped>

.listings-container {
  overflow-x: scroll;
  overflow-y: hidden;
}

.listings-container::-webkit-scrollbar {
  display: none;
}

.source-tag {
  margin-right: 8px;
}

.sources-container {
  margin-top: 0.3333em;
  margin-bottom: 1.5rem;
}

.query-title {
  margin-bottom: 0px;
}

.query-section {
  padding-bottom: 0px;
  padding-right: 0px;
}

.query-section .container {
  margin-right: 0px;
}

.query-price-range {
  margin-bottom: 0px;
  text-align: right;
}

.query-header {
  margin-bottom: 0px;
}

.query-header .column {
  padding-bottom: 0px;
}

.dashboard-view {
  margin-bottom: 48px;
}

.miniature-column {
  width: 21%;
}

.price-column {
  margin-right: 32px;
}

</style>